(function(){
/* CS: strict search + same-type related row.
   1) Search terms get quoted on submit -> kills Shopify semantic padding (no candy when searching cheetos).
   2) On /search, append a "You may also like" strip of products sharing the FIRST result's productType
      (source: /search/suggest.json?q=product_type:"X" - guaranteed same category). */
document.addEventListener('submit', function(e){
  var f = e.target;
  if(!f || f.tagName !== 'FORM') return;
  var action = (f.getAttribute('action') || '');
  if(action.indexOf('/search') !== 0) return;
  var inp = f.querySelector('input[name="q"]');
  if(inp && inp.value && inp.value.indexOf('"') === -1 && inp.value.indexOf(':') === -1){
    inp.value = inp.value.trim().split(/\s+/).map(function(w){ return '"' + w + '"'; }).join(' ');
  }
}, true);
if(location.pathname !== '/search') return;
function ready(fn){ if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }
ready(function(){
  var grid = document.getElementById('filter-results');
  if(!grid) return;
  var links = grid.querySelectorAll('a[href*="/products/"]');
  if(!links.length) return;
  var shown = {};
  links.forEach(function(a){
    var mm = a.getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
    if(mm) shown[mm[1]] = 1;
  });
  var m = links[0].getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
  if(!m) return;
  fetch('/products/' + m[1] + '.js').then(function(r){ return r.json(); }).then(function(p){
    if(!p || !p.type) return;
    var q = encodeURIComponent('product_type:"' + p.type + '"');
    return fetch('/search/suggest.json?q=' + q + '&resources[type]=product&resources[limit]=10')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var all = (d.resources && d.resources.results && d.resources.results.products) || [];
        var recs = all.filter(function(x){ return x.available && !shown[x.handle]; }).slice(0, 5);
        if(!recs.length) return;
        var wrap = document.createElement('div');
        wrap.className = 'cs-related-picks';
        wrap.style.cssText = 'margin:40px 0 20px;';
        var h = document.createElement('h3');
        h.textContent = 'You may also like';
        h.style.cssText = 'margin-bottom:16px;font-size:1.3em;';
        wrap.appendChild(h);
        var row = document.createElement('div');
        row.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:16px;';
        recs.forEach(function(x){
          var a = document.createElement('a');
          a.href = x.url;
          a.style.cssText = 'text-decoration:none;color:inherit;display:block;';
          var img = document.createElement('img');
          img.src = x.featured_image && x.featured_image.url ? x.featured_image.url : x.image;
          img.alt = x.title;
          img.loading = 'lazy';
          img.style.cssText = 'width:100%;aspect-ratio:1;object-fit:contain;border-radius:8px;background:#fff;';
          var t = document.createElement('div');
          t.textContent = x.title;
          t.style.cssText = 'font-size:0.85em;margin-top:8px;line-height:1.3;';
          var pr = document.createElement('div');
          pr.textContent = '$' + x.price;
          pr.style.cssText = 'font-weight:600;margin-top:4px;';
          a.appendChild(img); a.appendChild(t); a.appendChild(pr);
          row.appendChild(a);
        });
        wrap.appendChild(row);
        grid.appendChild(wrap);
      });
  }).catch(function(){});
});
})();